import {useTeamMembers} from "./teamMemberQueries.js";

/**
 * Hook to determine if the account is in solo or multi-user mode
 * Solo mode: Only the manager (no additional team members)
 * Multi-user mode: Manager + at least one worker or additional manager
 */
export function useIsMultiUser() {
  const {teamMembers, isTeamMembersLoading} = useTeamMembers();

  const isLoading = isTeamMembersLoading;
  const isMultiUserMode = !isLoading && teamMembers && teamMembers.length > 1;

  return isMultiUserMode;
}
